/**
 * Resolves which HTML element to render based on interactive props.
 * Returns the element tag name string.
 */
const resolveInteractiveElement = ({ as, href, clickable }) =>
  as || (href ? "a" : clickable ? "button" : "div");

/**
 * Resolves ARIA attributes for navigation items based on
 * whether the item is a link or button, and its active state.
 */
const resolveActiveProps = ({ href, active }) =>
  href
    ? active
      ? { "aria-current": "page" }
      : {}
    : { "aria-pressed": active };

export { resolveInteractiveElement, resolveActiveProps };
